import { List, Map, fromJS } from 'immutable';

export function request(state, { id, name }) {
    let items = state.get('items') || Map();
    let event = (items.get(id) || Map())
            .set('state', 'IN_PROGRESS')
            .set('errors', void 0);

    if (name) {
        event.set('name', name);
    }

    state = state.set(
        'items',
        items.set(id, event)
    );

    let opened = state.get('opened') || List();

    if (!opened.contains(id)) {
        opened = opened.push(id);
    }

    return state.set('opened', opened);
}

export function error(state, { id, errors }) {
    let items = state.get('items') || Map();
    let event = (items.get(id) || Map())
            .set('state', 'ERROR')
            .set('errors', fromJS(errors));

    return state.setIn([ 'items', id ], event);
}

export function finish(state, { id, event }) {
    let items = state.get('items') || Map();
    let eventEl = (items.get(id) || Map())
            .merge(fromJS(event))
            .set('name', event.name)
            .set('_full', true)
            .set('state', 'FINISHED')
            .set('errors', void 0);

    return state.setIn([ 'items', id ], eventEl);
}

export function clear(state) {
    return state.set('opened', List());
}
